<template>
  <div class="modalPage" :class="{on: isShow}">
    <!--header-->
    <header class="header">
      <div class="header__inner type_02">
        <h2 class="header__ttl">주소 검색</h2>
        <div class="header__btns">
          <button @click="fnClose()">닫기</button>
        </div>
      </div>
    </header>
    <!--main-->
    <main class="main" role="main">
      <div class="main__inner"><!-- 배경: bg-->
        <div class="main__con">
          <div class="sign__page">
            <vue-daum-postcode
              style="height: 100%;"
              :animation="false"
              :no-shorthand="false"
              :no-autoMapping="false"
              v-on:complete="fnSelectAddress($event)"
            />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script type="text/javascript" src="//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"></script>
<script>
import {VueDaumPostcode} from 'vue-daum-postcode'

export default {
  components: {VueDaumPostcode},
  name: 'address-modal',
  props: {
    callBack: {
      type: [Function]
    },
    isShow: {}
  },
  created: function () {
  },
  methods: {
    fnClose: function () {
      this.$emit('eventClose')
    },
    fnSelectAddress: function (item) {
      if (this.callBack !== undefined && this.callBack !== null) {
        this.callBack(item)
        this.$emit('eventClose', -2)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  background-color: white;
  padding: 1rem;

  h2 {
    display: inline-block;
    vertical-align: top;
    width: 50%;
  }

  .header__btns {
    display: inline-block;
    vertical-align: top;
    width: 50%;
    text-align: right;

    button {
      background: none;
      font-size: 14px;
      font-weight: bold;
      border: 0;
      cursor: pointer;
    }
  }
}

.modalPage {
  position: fixed;
  //transition-property: top;
  //transition-duration: 0s;
  //transition-delay: 0s;
  top: 100vh;
  width: 50rem;
  left: 50%;
  margin-left: -25rem;
  z-index: 100;
  border: 2px solid #E1E1E1;
  border-radius: 7px;
}

.modalPage.on {
  transition-property: top;
  transition-duration: 0.5s;
  transition-delay: 0s;
  top: 5rem;
}
</style>
